import { NextSeo } from "next-seo";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { ResetPasswordPage } from "@nju/feature-portal-reset-password";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function ResetPassword() {
  return (
    <LayoutWrapper>
      <NextSeo nofollow={true} noindex={true} />
      <Header />
      <BlockContent spacing="l">
        <ClientSideOnly>
          <ResetPasswordPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
